import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const ContentMasteryTestSpeechRateSummary = (props) => (
  <KpiSummary
    isLoading={props.isLoading}
    title="Speech recognition difficulty"
    previousValue={props.previousValue}
    currentValue={props.currentValue}
    formatter={props.formatter}
  />
);

ContentMasteryTestSpeechRateSummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

ContentMasteryTestSpeechRateSummary.defaultProps = {
  isLoading: false,
};

export default ContentMasteryTestSpeechRateSummary;
